import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import Clarity from '@microsoft/clarity';

import App from './App';

const TRACKING_ID = 'G-0N9QS6Y4XV';
ReactGA.initialize(TRACKING_ID);

const projectId = 'p90mhvuvb3';

Clarity.init(projectId);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
